import React, { Fragment, useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";
import { Link } from "react-router-dom";
import { _Blog_ } from "../../../Redux/Action/Action";
import { useDispatch, useSelector } from "react-redux";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loader, setLoader] = useState(false);
  const itemsPerPage = 8;
  const [hasMoreItems, sethasMoreItems] = useState(true);
  const [records, setrecords] = useState(itemsPerPage);
  const place = useSelector(state => state.place);
  const dispatch = useDispatch();
  const showItems = (blogs) => {
    var items = [];
    for (var i = 0; i < records; i++) {
      items.push(<> {blogs[i]}</>);
    }
    return items;
  };

  let loadMore = async () => {
    let payload = {
      key: keyword
    }
    let apiRes = await apiData.blog(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      setLoader(true);
      setBlogs(apiRes?.data?.data);
      setLoader(false);
      if (records >= apiRes?.data?.data.length) {
        sethasMoreItems(false);

      } else {
        setTimeout(() => {
          setrecords(records + itemsPerPage);
        }, 2000);
      }
    }
    else {
      console.log("server error");
    }

  };
  useEffect(() => {
    dispatch(_Blog_())
    loadMore();
  }, [keyword]);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <Fragment>
      <div className="flight-sec Things-sec">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              {!loader ? (
                <div data-aos="zoom-in-right" className="slider-sec">
                  <div className="slider-header">
                    <div className="blog-title">
                      <h3>Our Featured Blogs</h3>
                      <p>
                        Find fun places to see and things to do experience
                        the art, museums, music, zoos
                      </p>
                    </div>
                    <div className="searcher-sec" style={{ position: 'relative' }}>
                      <input
                        className="form-control"
                        placeholder="Search ..."
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        style={{ paddingRight: '30px' }}
                      />

                      {keyword && (
                        <span
                          onClick={() => setKeyword('')}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            fontSize: '18px',
                            color: '#888'
                          }}
                        >
                          &times;
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12">
                    <InfiniteScroll
                      loadMore={loadMore}
                      hasMore={hasMoreItems}
                      loader={<div className="autoLoading" style={{ textAlign: "center", fontSize: "38px" }}>loading...</div>}
                      endMessage={<p style={{ textAlign: "center" }}>No more items to show</p>}
                    // useWindow={false}
                    >
                      <div className="small-blog">
                        {blogs && blogs.length > 0 ? (
                          showItems(
                            blogs.map((ele) => (
                              <div data-aos="zoom-in-right" className="blog-main" key={ele?.id}>
                                <Link to={`/blog/${ele?.slug}`}>
                                  <div className="right_blog_img">
                                    <img loading="lazy" src={ele?.image} alt="blogpost" />
                                  </div>
                                  <div className="blog-content">
                                    <div className="date-sec">
                                      <p>
                                       <img src="/images/Calendar.svg" alt="Calendar Icon" />
                                        {new Intl.DateTimeFormat('en', {
                                          day: "numeric",
                                          month: "long",
                                          year: "numeric",
                                        }).format(new Date(ele?.date))}
                                      </p>
                                    </div>
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: ele?.title }}></p>
                                  </div>
                                </Link>
                              </div>
                            ))
                          )
                        ) : (
                          <p style={{ textAlign: "center", marginTop: "1rem", fontWeight: 500 }}>
                            No results found for "{keyword}"
                          </p>
                        )}
                      </div>
                    </InfiniteScroll>
                  </div>

                </div>
              ) : (
                <DataLoader />
              )}
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
}
export default Blog;
